module.exports = __webpack_public_path__ + "static/media/right-action.ef6b1684.mp3";